/* GenuinePurity Black Friday sale page (sections/gp-bf-sale.liquid)
   - applies the sale discount code on load
   - category tabs filter the grid in place
   - "Add To Cart" adds the single-bottle variant and opens the cart drawer
   - "Learn More" opens a quick-view modal with a draggable image carousel */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.querySelector('[data-bf-sale]');
    if (!root) return;

    /* ---------- discount code ---------- */
    var code = (root.getAttribute('data-discount-code') || '').trim();
    if (code) {
      // Put the code on the cart (Cart API "discount"), which works on the live site, theme previews and the
      // local preview. Fall back to the /discount/CODE link if that is refused. Then let listeners
      // (e.g. the Mix & Match progress bar) know the cart changed.
      var applied = function () {
        try { document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true })); } catch (e) { /* ignore */ }
      };
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart update ' + r.status); applied(); })
        .catch(function () {
          return fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
            .then(applied);
        })
        .catch(function () { /* non-fatal: the code can still be entered at checkout */ });
    }

    /* ---------- tabs ---------- */
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-bf-tab]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('.bf-sale__item'));
    var empty = root.querySelector('[data-bf-empty]');

    function showTab(handle) {
      var visible = 0;
      items.forEach(function (li) {
        var card = li.querySelector('[data-bf-card]');
        var hit = !handle || (card && card.getAttribute('data-collections').indexOf(' ' + handle + ' ') !== -1);
        li.hidden = !hit;
        if (hit) visible++;
      });
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-bf-tab') === handle;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (empty) empty.hidden = visible > 0;
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        showTab(t.getAttribute('data-bf-tab'));
        t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
    });

    /* ---------- add to cart ---------- */
    var toast = root.querySelector('[data-bf-toast]');
    var toastTimer;
    function say(msg) {
      if (!toast) return;
      toast.textContent = msg;
      toast.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.hidden = true; }, 3500);
    }

    function openCart() {
      try {
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
          window.Rebuy.SmartCart.show();
          return;
        }
      } catch (e) { /* fall through */ }
      try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) { /* ignore */ }
    }

    function addToCart(btn) {
      var id = Number(btn.getAttribute('data-bf-add'));
      if (!id || btn.disabled) return;
      var label = btn.innerHTML;
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) throw new Error(body && (body.description || body.message) || 'Could not add to cart');
            return body;
          });
        })
        .then(function () {
          btn.textContent = 'Added ✓';
          try { document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true })); } catch (e) { /* ignore */ }
          if (modal && !modal.hidden) closeModal();
          openCart();
          setTimeout(function () { btn.innerHTML = label; btn.disabled = false; btn.classList.remove('is-loading'); }, 1800);
        })
        .catch(function (e) {
          say(e.message || 'Could not add to cart');
          btn.innerHTML = label;
          btn.disabled = false;
          btn.classList.remove('is-loading');
        });
    }

    root.addEventListener('click', function (e) {
      var add = e.target.closest('[data-bf-add]');
      if (add && root.contains(add)) { e.preventDefault(); addToCart(add); return; }
      var learn = e.target.closest('[data-bf-learn]');
      if (learn && root.contains(learn)) { e.preventDefault(); openModal(learn.getAttribute('data-bf-learn'), learn); return; }
      if (e.target.closest('[data-bf-close]')) { e.preventDefault(); closeModal(); }
    });

    /* ---------- quick view modal ---------- */
    var modal = root.querySelector('[data-bf-modal]');
    var content = root.querySelector('[data-bf-modal-content]');
    var dialog = modal && modal.querySelector('[role="dialog"]');
    var lastFocus = null;

    function openModal(productId, trigger) {
      var tpl = root.querySelector('template[data-bf-qv="' + productId + '"]');
      if (!tpl || !modal) return;
      lastFocus = trigger || document.activeElement;
      content.innerHTML = '';
      content.appendChild(tpl.content.cloneNode(true));
      modal.hidden = false;
      document.documentElement.classList.add('bf-modal-open');
      initCarousel(content);
      requestAnimationFrame(function () { dialog.focus(); markMore(); });
      content.querySelectorAll('img').forEach(function (img) { img.addEventListener('load', markMore); });
    }

    // .has-more on the dialog while content below is hidden (shows the shadow on the pinned buy row)
    function markMore() {
      if (!dialog || modal.hidden) return;
      dialog.classList.toggle('has-more', dialog.scrollTop + dialog.clientHeight < dialog.scrollHeight - 2);
    }
    if (dialog) dialog.addEventListener('scroll', markMore, { passive: true });
    window.addEventListener('resize', markMore);

    function closeModal() {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      content.innerHTML = '';
      document.documentElement.classList.remove('bf-modal-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('keydown', function (e) {
      if (!modal || modal.hidden) return;
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key === 'Tab') {   // keep focus inside the dialog
        var f = dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    /* ---------- draggable carousel ---------- */
    function initCarousel(scope) {
      var track = scope.querySelector('[data-bf-track]');
      if (!track) return;
      var dots = Array.prototype.slice.call(scope.querySelectorAll('[data-bf-dot]'));
      var count = track.children.length;
      var current = function () { return Math.round(track.scrollLeft / track.clientWidth); };
      var go = function (i) {
        i = Math.max(0, Math.min(count - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      };
      var mark = function () {
        var i = current();
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      };
      track.addEventListener('scroll', function () { requestAnimationFrame(mark); }, { passive: true });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(Number(d.getAttribute('data-bf-dot'))); }); });
      var prev = scope.querySelector('[data-bf-prev]'), next = scope.querySelector('[data-bf-next]');
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
      });

      // Mouse / pen drag (touch already swipes natively). Snap to the nearest slide on release.
      var startX = 0, startScroll = 0, dragging = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || count < 2) return;
        dragging = true; startX = e.clientX; startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(e.pointerId); } catch (err) { /* keep dragging without capture */ }
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        track.scrollLeft = startScroll - (e.clientX - startX);
      });
      var end = function (e) {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        var moved = e.clientX - startX;
        var i = Math.round(startScroll / track.clientWidth);
        if (Math.abs(moved) > track.clientWidth * 0.15) i += moved < 0 ? 1 : -1;
        go(i);
      };
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
    }
  });
})();
